'use strict';

import ApiEndpoint from './api_endpoint';

export default class ListMyProtocolSubscriptions extends ApiEndpoint {
  execute(callback = undefined, session = undefined) {
    if (session === undefined) {
      return this.session.get('/protocol_subscriptions/mine', undefined, callback);
    }
    return session.get('/protocol_subscriptions/mine', undefined, callback);
  }
}
